import React from 'react';

import { EmblemContext } from './EmblemContext';
import { EmblemSize, EmblemVariant } from './types';

type EmblemProviderProps = {
  emblemActive?: boolean;
  variant: EmblemVariant;
  size: EmblemSize;
};

export const EmblemProvider: React.FC<EmblemProviderProps> = ({
  emblemActive = false,
  variant,
  size,
  children,
}) => {
  const providerValue = React.useMemo(
    () => ({ variant, size, active: emblemActive }),
    [size, variant, emblemActive],
  );

  return <EmblemContext.Provider value={providerValue}>{children}</EmblemContext.Provider>;
};
